export default __webpack_public_path__ + "static/media/about-lg-leaf1.fafed641.svg";